import { useMemo } from 'react';
import { DateTime } from 'luxon';
import {
  getClientFacet,
  getProjectFacet,
  getOefFacet,
  getActivityFacet,
  getBillingFacet,
  getProgramFacet
} from 'modules/notes/common/components/SearchFacets';
import { getCustomLabelFacet } from 'modules/notes/common/components/SearchFacets/CustomLabelFacet';
import DateRangeFacet from 'modules/notes/common/components/SearchFacets/DateRangeFacet';
import { SearchFacetType } from 'modules/notes/common/components/SearchFacets';
import { LabelType } from 'graphql/types';
import { useLabels } from 'modules/common/hooks';

export const useSearchFacets = ({
  hideDaterangeFacet
}: {
  hideDaterangeFacet?: boolean;
}): SearchFacetType[] => {
  const { timesheetLabels, customLabels } = useLabels(DateTime.local());

  return useMemo(() => {
    const customLabelFacet: SearchFacetType[] = [];
    const facets = !hideDaterangeFacet ? [DateRangeFacet] : [];

    const clientLabel = timesheetLabels.find(
      ({ type }) => type === LabelType.Client
    );
    const programLabel = timesheetLabels.find(
      ({ type }) => type === LabelType.Program
    );
    const projectLabel = timesheetLabels.find(
      ({ type }) => type === LabelType.Project
    );
    const billingLabel = timesheetLabels.find(
      ({ type }) => type === LabelType.Billing
    );
    const activityLabel = timesheetLabels.find(
      ({ type }) => type === LabelType.Activity
    );

    const oefFacets = timesheetLabels
      .filter(({ type }) => type === LabelType.Select)
      .map((i) => getOefFacet(i));

    if (clientLabel) {
      facets.push(getClientFacet(clientLabel));
    }
    if (programLabel) {
      facets.push(getProgramFacet(programLabel));
    }
    if (projectLabel) {
      facets.push(getProjectFacet(projectLabel));
    }
    if (billingLabel) {
      facets.push(getBillingFacet(billingLabel));
    }
    if (activityLabel) {
      facets.push(getActivityFacet(activityLabel));
    }
    if (customLabels.length) {
      customLabelFacet.push(getCustomLabelFacet(customLabels));
    }

    return [...facets, ...oefFacets, ...customLabelFacet];
  }, [customLabels, hideDaterangeFacet, timesheetLabels]);
};
